import { createSelector } from 'reselect'

import { fetchingStatusesSelector, isBoostrappedSelector } from 'selectors/app'
import {
  selectCurrentMailboxId,
  selectCurrentMailboxName,
} from 'selectors/mailboxes'
import { selectIsTicketSelectionMode } from 'selectors/ticket_list/base'

import { addPath } from 'util/labels'
import { selectLabels, selectLabelsByMailboxId } from './base'

const selectLabelIdsForCurrentMailbox = createSelector(
  selectCurrentMailboxId,
  selectLabelsByMailboxId,
  (currentMailboxId, byMailboxId) => byMailboxId[currentMailboxId]
)

export const shouldFetchTopLabelsForSelection = createSelector(
  isBoostrappedSelector,
  selectIsTicketSelectionMode,
  fetchingStatusesSelector,
  selectLabelIdsForCurrentMailbox,
  (bootstrapped, isSelecting, statuses, labelIds) => {
    return (
      bootstrapped &&
      isSelecting &&
      !statuses.fetchTopLabelsForSelection &&
      !labelIds
    )
  }
)

export const selectTopLabels = createSelector(
  selectLabels,
  selectLabelsByMailboxId,
  selectCurrentMailboxId,
  (allLabels, byMailboxId, mailboxId) => {
    const mailboxTopLabels = byMailboxId[mailboxId]
    const mailboxHasTopLabels = mailboxTopLabels && mailboxTopLabels.length > 0
    return mailboxHasTopLabels ? mailboxTopLabels : allLabels.slice(0, 10)
  }
)

export const selectTopLabelsAreLoaded = createSelector(
  selectLabelsByMailboxId,
  selectCurrentMailboxId,
  (byMailboxId, mailboxId) => {
    return !!byMailboxId[mailboxId]
  }
)

export const selectTopLabelNames = createSelector(selectTopLabels, labels =>
  labels.map(label => label.name)
)

export const selectTopLabelsWithPath = createSelector(
  selectTopLabels,
  selectCurrentMailboxName,
  (labels, mailboxName) => labels.map(addPath(mailboxName))
)
